import { render, staticRenderFns } from "./ManageHistory.vue?vue&type=template&id=17c763ea&scoped=true"
import script from "./ManageHistory.vue?vue&type=script&lang=js"
export * from "./ManageHistory.vue?vue&type=script&lang=js"
import style0 from "./ManageHistory.vue?vue&type=style&index=0&id=17c763ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c763ea",
  null
  
)

export default component.exports